import { CommonModule } from '@angular/common'
import {
  Component, ChangeDetectionStrategy, Input, ViewEncapsulation,
} from '@angular/core'

export type HeadingLevel = 1 | 2 | 3 | 4 | 'none'

@Component({
  selector: 'kb-variable-heading',
  templateUrl: './variable-heading.component.html',
  styleUrls: ['./variable-heading.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
  encapsulation: ViewEncapsulation.None,
})
export class VariableHeadingComponent {
  @Input() public level?: HeadingLevel
}
